import React from 'react'

/**
 * Section header for pilot sections (Sans/Avec pilote)
 * Displays bilingual title with blue text
 */
export const SectionHeader = ({ titleFr, titleEn, superscripts = '' }) => {
    return (
        <h2
            style={{
                color: '#1890ff',
                margin: '20px 0 10px 0',
            }}
        >
            {titleFr}
            {superscripts && <sup>{superscripts}</sup>} / {titleEn}
            {superscripts && <sup>{superscripts}</sup>}
        </h2>
    )
}
